module.exports = __webpack_public_path__ + "static/media/group-cover-5.a8065a9c.jpg";